// @owners { team: patients }
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { get } from '~shared/helpers/apiHelper';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';
import { queryClient } from '~shared/react-query/queryClient';
import { type Shipment } from '~shared/types';

const SHIPMENTS_API_VERSION = 'v3';

// Query keys only — no hooks/store imports here so action files (e.g. deliveries) can
// invalidate `shipments` without a store↔actions circular import. Hooks live in
// queries/useShipments.ts. See the redux-thunk-to-react-query-migration skill.
export const shipments = createQueryKeys('shipments', {
  fetchAll: {
    queryKey: null,
    queryFn: async (): Promise<Shipment[]> => {
      const response = await get('/shipments', {}, { version: SHIPMENTS_API_VERSION });
      if (response.error) {
        throw new Error(getErrorMessageFromResponse(response));
      }
      return response;
    },
  },
});

/**
 * Force a refetch of the shipments query (the bridge then mirrors it into Redux). Replaces the
 * old `dispatch(fetchShipments())` refresh calls. Store-free so action files can call it too.
 */
export const invalidateShipments = () => queryClient.invalidateQueries({ queryKey: shipments.fetchAll.queryKey });
